import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData, selectExtraRoutesAuthData } from '@/containers/Login/AuthSelectors'
/* import {
  selectBillingSubscriptionData,
  selectCustomerSubscriptionData,
  selectEnergyCharacteristicsSubscriptionData,
  selectMainAddressSubscriptionData,
  selectTelecomContractSubscriptionData,
} from '../SubscriptionFormSelectors' */
// import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'
/* import {
  selectBankingModuleConfigurationData,
  selectCommonFormConfigurationData,
  selectCustomerModuleConfigurationData,
} from '../SubscriptionFormConfigurationSelectors' */
import { updateAdditionalSalesData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { deleteCommonFormErrors } from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSlice'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { selectAdditionalSalesConfig } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import {
  selectPersonalClientSubscriptionData,
  selectPreferencesClientSubscriptionData,
  selectProfessionalClientSubscriptionData,
} from '../../SubscriptionForm/SubscriptionFormSelectors'

const useAdditionalSaleFormData = () => {
  const dispatch = useDispatch()
  const { zohoId, firstName, lastName, civility, phone1, phone2, email, birthdate } = useSelector(
    selectPersonalClientSubscriptionData,
  )

  const { socialReason, siret } = useSelector(selectProfessionalClientSubscriptionData)
  const { clientType } = useSelector(selectPreferencesClientSubscriptionData)

  const { sales: additionalSales } = useSelector(selectAdditionalSalesConfig)

  const { saveAdditionalSaleLeadUrl } = useSelector(selectExtraRoutesAuthData) || {}
  const { iban = '', bic } = {} // useSelector(selectBillingSubscriptionData)
  const { isMcpAgent, country } = useSelector(selectAuthData)
  const { streetNumber, city, zipcode, address, inseeCode, housingType, tenantType } = {} // useSelector(
  // selectMainAddressSubscriptionData,
  // )
  const { prestationType } = {} //  useSelector(selectEnergyCharacteristicsSubscriptionData)

  const { providerId } = {} // useSelector(selectTelecomContractSubscriptionData)

  const { type: businessType } = useBusinessType({
    loaderRoutesEnergy: {},
    loaderRoutesInsurance: {},
    loaderRoutes: {},
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })

  const removeErrors = error => {
    dispatch(deleteCommonFormErrors(error))
  }

  const findProductInList = (products, name) => {
    const product = products.find(o => o.name === name)
    if (product === 'undefined') {
      return ''
    }
    return product
  }

  const findProductById = (products, id) => {
    const product = products.find(o => o.id === parseInt(id))
    if (product === 'undefined') {
      return ''
    }
    return product
  }

  const subscription = null
  /* const isAlreadyMonConseillerPerso =
    !!subscription?.sale_mon_conseiller_perso && subscription.sale_mon_conseiller_perso.status_code !== 'abandon' */
  const { token, isEditable, mandatoryFields, errors } = {} // useSelector(selectCommonFormConfigurationData)
  const agentEmail = subscription?.created_by?.email ?? ''

  const retrieveProductsListOfSale = saleName => {
    if (!additionalSales[saleName]) {
      return []
    }
    return additionalSales[saleName].sales || []
  }

  const retrieveResourcesOfSale = saleName => {
    if (!additionalSales[saleName]) {
      return []
    }
    return additionalSales[saleName].resources || []
  }

  const updateLead = (data, name) => {
    dispatch(updateAdditionalSalesData({ data, name }))
  }

  return {
    zohoId,
    firstName,
    lastName,
    civility,
    phone1,
    phone2,
    email,
    birthdate,
    socialReason,
    siret,
    prestationType,
    clientType,
    iban,
    bic,
    streetNumber,
    city,
    zipcode,
    address,
    inseeCode,
    agentEmail,
    housingType,
    tenantType,
    country,
    providerId,
    token,
    isEditable,
    businessType,
    mandatoryFields,
    errors,
    removeErrors,
    updateLead,
    retrieveProductsListOfSale,
    findProductInList,
    retrieveResourcesOfSale,
    findProductById,
    saveAdditionalSaleLeadUrl,
    showOnlyAllowLeadMcp: false, // todo-v2: check this !isMcpAgent && isAlreadyMonConseillerPerso,
    haveAlreadyAnyLead:
      !!subscription?.sale_telecom_energy ||
      !!subscription?.sale_telecom ||
      !!subscription?.sale_verisure_telecom ||
      !!subscription?.sale_assurance_default ||
      !!subscription?.sale_assurance_emprunteur,
  }
}

export default useAdditionalSaleFormData
